import styled from 'styled-components';
import { Switch as MUISwitch } from '@mui/material';
import colours from 'theme/atoms/colours';

const Switch = styled(MUISwitch).attrs({
  focusVisibleClassName: '.Mui-focusVisible',
  disableRipple: true,
})`
  display: flex;
  width: 68px;
  height: 34px;
  padding: 0;
  justify-content: flex-end;
  align-items: center;
  gap: 5px;
  box-sizing: border-box;
  .MuiSwitch-switchBase {
    padding: 4px;
    margin: 0;
    top: 0;
    left: 0;
    transition-duration: 300ms;
    &.Mui-checked {
      transform: translateX(34px);
      color: #fff;
      & + .MuiSwitch-track {
        background: #20b941;
        backdrop-filter: blur(8px);
        opacity: 1;
        border: 0;
      }
      &.Mui-disabled + .MuiSwitch-track {
        opacity: 0.5;
      }
    }
    &.Mui-focusVisible .MuiSwitch-thumb {
      color: ${colours.primary[500]};
      border: 6px solid #fff;
    }
    &.Mui-disabled .MuiSwitch-thumb {
      color: white;
    }
    &.Mui-disabled + .MuiSwitch-track {
      opacity: 0.7;
    }
  }
  & .MuiSwitch-thumb {
    box-shadow: none;
    box-sizing: border-box;
    width: 26px;
    height: 26px;
  }
  & .MuiSwitch-track {
    border-radius: 100px;
    height: 100%;
    background-color: ${colours.neutral[200]};
    opacity: 1;
    backdrop-filter: blur(8px);
  }
`;

export default Switch;
